import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './auth-guard';
import { PickemCricketPage } from './games/pickem-lobbypage/pickem-cricket/pickem-cricket.page';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'splashdefault',
    pathMatch: 'full'
  },
  {
    path: 'signup',
    loadChildren: () => import('./signuppage/signuppage.module').then(m => m.SignupPageModule)
  },
  {
    path: 'signup/:page',
    loadChildren: () => import('./signuppage/signuppage.module').then(m => m.SignupPageModule)
  },
  {
    path: 'otp',
    loadChildren: () => import('./otppage/otppage.module').then(m => m.OtpPageModule)
  },
  {
    path: 'referral',
    loadChildren: () => import('./referralpage/referralpage.module').then(m => m.ReferralPageModule)
  },
  {
    path: 'congratulations',
    loadChildren: () => import('./congratulationspage/congratulationspage.module').then(m => m.CongratulationsPageModule)
  },
  {
    path: 'emailpage',
    loadChildren: () => import('./emailpage/emailpage.module').then(m => m.EmailpagePageModule)
  },
  {
    path: 'usernamepage',
    loadChildren: () => import('./usernamepage/usernamepage.module').then(m => m.UsernamepagePageModule)
  },
  // {
  //   path: 'dashboardpage',
  //   loadChildren: () => import('./dashboardpage/dashboardpage.module').then(m => m.DashboardpagePageModule),
  //   // canActivate: [AuthGuard],
  // },
  // {
  //   path: 'dashboardpage/:page',
  //   loadChildren: () => import('./dashboardpage/dashboardpage.module').then(m => m.DashboardpagePageModule),
  //   // canActivate: [AuthGuard],
  // },
  // {
  //   path: 'dashboardpage/:page/:matchId/:contestId',
  //   loadChildren: () => import('./dashboardpage/dashboardpage.module').then(m => m.DashboardpagePageModule),
  //   // canActivate: [AuthGuard],
  // },
  // {
  //   path: 'dashboardpage/:page/:matchId/:contestId/:fromTeam',
  //   loadChildren: () => import('./dashboardpage/dashboardpage.module').then(m => m.DashboardpagePageModule),
  //   // canActivate: [AuthGuard],
  // },

  {
    path: 'lobbypage',
    loadChildren: () => import('./lobbypage/lobbypage.module').then(m => m.LobbypagePageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'splashdefault',
    loadChildren: () => import('./splashdefault/splashdefault.module').then( m => m.SplashdefaultPageModule)
  },
  {
    path: 'splashdefault/:page',
    loadChildren: () => import('./splashdefault/splashdefault.module').then( m => m.SplashdefaultPageModule)
  },
  {
    path: 'splashdefault/:page/:matchId/:contestId',
    loadChildren: () => import('./splashdefault/splashdefault.module').then( m => m.SplashdefaultPageModule)
  },
  {
    path: 'splashdefault/:page/:matchId/:contestId/:fromTeam',
    loadChildren: () => import('./splashdefault/splashdefault.module').then( m => m.SplashdefaultPageModule)
  },
  {
    path: 'mywallet',
    loadChildren: () => import('./mywallet/mywallet.module').then(m => m.MywalletPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'faq',
    loadChildren: () => import('./faq/faq.module').then(m => m.FaqPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'mycontest',
    loadChildren: () => import('./mycontest/mycontest.module').then(m => m.MycontestPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'more',
    loadChildren: () => import('./more/more.module').then(m => m.MorePageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'createcontestpage',
    loadChildren: () => import('./createcontestpage/createcontestpage.module').then(m => m.CreatecontestpagePageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'whatsnewpage',
    loadChildren: () => import('./whatsnewpage/whatsnewpage.module').then(m => m.WhatsnewpagePageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'referpage',
    loadChildren: () => import('./referpage/referpage.module').then(m => m.ReferpagePageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'referfriendmodel',
    loadChildren: () => import('./referfriendmodel/referfriendmodel.module').then(m => m.ReferfriendmodelPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'aboutus',
    loadChildren: () => import('./aboutus/aboutus.module').then(m => m.AboutusPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'termsandcondtion',
    loadChildren: () => import('./termsandcondtion/termsandcondtion.module').then(m => m.TermsandcondtionPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'rulespage',
    loadChildren: () => import('./rulespage/rulespage.module').then(m => m.RulespagePageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'privacy-policy',
    loadChildren: () => import('./privacy-policy/privacy-policy.module').then(m => m.PrivacyPolicyPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'contactus',
    loadChildren: () => import('./contactus/contactus.module').then(m => m.ContactusPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'legality',
    loadChildren: () => import('./legality/legality.module').then(m => m.LegalityPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'offerpage',
    loadChildren: () => import('./offerpage/offerpage.module').then(m => m.OfferpagePageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'how-to-play',
    loadChildren: () => import('./how-to-play/how-to-play.module').then(m => m.HowToPlayPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'cricket',
    loadChildren: () => import('./lobbypage/cricket/cricket.module').then(m => m.CricketPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'football',
    loadChildren: () => import('./lobbypage/football/football.module').then(m => m.FootballPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'tabs',
    loadChildren: () => import('./pages/tabs/tabs.module').then(m => m.TabsPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'joincontest',
    loadChildren: () => import('./joincontest/joincontest.module').then(m => m.JoincontestPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'mywallet',
    loadChildren: () => import('./mywallet/mywallet.module').then(m => m.MywalletPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'addfunds',
    loadChildren: () => import('./mywallet/addfunds/addfunds.module').then(m => m.AddfundsPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'applypromocode',
    loadChildren: () => import('./mywallet/applypromocode/applypromocode.module').then(m => m.ApplypromocodePageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'profile',
    loadChildren: () => import('./profile/profile.module').then( m => m.ProfilePageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'transaction-history',
    loadChildren: () => import('./transaction-history/transaction-history.module').then( m => m.TransactionHistoryPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'pick-mobile',
    loadChildren: () => import('./pick-mobile/pick-mobile.module').then( m => m.PickMobilePageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'contest-listing',
    loadChildren: () => import('./contest-listing/contest-listing.module').then( m => m.ContestListingPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'contest-detail',
    loadChildren: () => import('./contest-listing/contest-detail/contest-detail.module').then( m => m.ContestDetailPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'contest-detail/:matchId',
    loadChildren: () => import('./contest-listing/contest-detail/contest-detail.module').then( m => m.ContestDetailPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'contest-detail/:matchId/:contestId',
    loadChildren: () => import('./contest-listing/contest-detail/contest-detail.module').then( m => m.ContestDetailPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'createteams',
    loadChildren: () => import('./createteams/createteams.module').then( m => m.CreateteamsPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'notifications',
    loadChildren: () => import('./notifications/notifications.module').then( m => m.NotificationsPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'app-update',
    loadChildren: () => import('./app-update/app-update.module').then( m => m.AppUpdatePageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'games',
    loadChildren: () => import('./games/games.module').then( m => m.GamesPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'games/pickem-lobbypage/:matchId/:fromTeam/:ff',
    loadChildren: () => import('./games/pickem-lobbypage/pickem-lobbypage.module').then( m => m.PickemLobbypagePageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'pickem-tabs',
    loadChildren: () => import('./pages/pickem-tabs/pickem-tabs.module').then( m => m.PickemTabsPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'mycontest-pickem',
    loadChildren: () => import('./mycontest-pickem/mycontest-pickem.module').then( m => m.MycontestPickemPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'withdrawalmoney',
    loadChildren: () => import('./withdrawalmoney/withdrawalmoney.module').then( m => m.WithdrawalmoneyPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'withdrawalpending',
    loadChildren: () => import('./withdrawalpending/withdrawalpending.module').then( m => m.WithdrawalpendingPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'accountmanagement',
    loadChildren: () => import('./accountmanagement/accountmanagement.module').then( m => m.AccountmanagementPageModule)
  }

];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { 
      preloadingStrategy: PreloadAllModules,
      // enableTracing: true,
      // initialNavigation: true,
      // relativeLinkResolution: 'corrected', // Fix Router BUG
      // disableUrlEncoding: true // Suggest something like this: but would need documentation
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
